import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative pt-24 sm:pt-32 pb-16 sm:pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background Image - Optimized for LCP */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 via-purple-600/20 to-pink-600/20">
        <img
          src="/images/michal-parzuchowski-U8n_O7rEq7o-unsplash.webp"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-20"
          loading="eager"
          fetchPriority="high"
          decoding="async"
          width="1920"
          height="1080"
          style={{ imageRendering: 'auto' }}
          aria-hidden="true"
        />
      </div>
      
      <div className="relative max-w-7xl mx-auto text-center">
        <div className="inline-flex items-center space-x-2 glass px-4 py-2 rounded-full mb-6">
          <Sparkles className="text-yellow-400" size={20} />
          <span className="text-white/90 text-sm">Your Trusted UK Casino Guide</span>
        </div>
        
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          Find Your Perfect
          <span className="block bg-gradient-to-r from-yellow-400 via-orange-500 to-pink-500 bg-clip-text text-transparent">
            Casino Match
          </span>
        </h1>
        
        <p className="text-lg sm:text-xl md:text-2xl text-white/80 mb-6 sm:mb-10 max-w-3xl mx-auto leading-relaxed">
          We've done the research so you don't have to. Compare top-rated UK casinos, 
          exclusive bonuses, and trusted reviews all in one place.
        </p>
        
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          <a
            href="#offers"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('offers')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
            className="glass px-6 py-3 rounded-xl text-white/90 font-semibold hover:text-white hover:bg-white/20 transition-all duration-300 text-sm md:text-base"
          >
            Offers
          </a>
          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('about')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
            className="glass px-6 py-3 rounded-xl text-white/90 font-semibold hover:text-white hover:bg-white/20 transition-all duration-300 text-sm md:text-base"
          >
            About Us
          </a>
          <a
            href="#guides"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('guides')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
            className="glass px-6 py-3 rounded-xl text-white/90 font-semibold hover:text-white hover:bg-white/20 transition-all duration-300 text-sm md:text-base"
          >
            Guides
          </a>
          <a
            href="#faq"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
            className="glass px-6 py-3 rounded-xl text-white/90 font-semibold hover:text-white hover:bg-white/20 transition-all duration-300 text-sm md:text-base"
          >
            FAQ
          </a>
          <a
            href="#news"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('news')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
            className="glass px-6 py-3 rounded-xl text-white/90 font-semibold hover:text-white hover:bg-white/20 transition-all duration-300 text-sm md:text-base"
          >
            News
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
            className="glass px-6 py-3 rounded-xl text-white/90 font-semibold hover:text-white hover:bg-white/20 transition-all duration-300 text-sm md:text-base"
          >
            Contact
          </a>
        </div>
        
        
      </div>
    </section>
  );
};

export default Hero;

